import { ASSETS } from '@/constants/assets';

const TRUST_CHECKS = [
  'Engenharia especializada',
  'Atendimento técnico',
  'Componentes novos',
  'Recuperação certificada',
];

export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center pt-[120px] md:pt-[176px] overflow-hidden">

      {/* ─── BACKGROUND IMAGE ─── */}
      <div className="absolute inset-0" aria-hidden="true">
        <img
          src={ASSETS.hero.main}
          alt="Escavadeira hidráulica de grande porte em operação em ambiente de mineração, com cilindro hidráulico cromado em primeiro plano — Engenharia DURAFLOW"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
      </div>

      {/* ─── OVERLAY ─── */}
      <div
        className="absolute inset-0 bg-gradient-to-r from-secondary-950/80 via-secondary-950/55 to-secondary-950/25"
        aria-hidden="true"
      ></div>

      {/* Subtle bottom-to-top vignette */}
      <div
        className="absolute inset-0 bg-gradient-to-t from-secondary-950/30 via-transparent to-transparent"
        aria-hidden="true"
      ></div>

      {/* ─── CONTENT ─── */}
      <div className="relative z-10 max-w-container mx-auto px-4 md:px-6 w-full">
        <div className="max-w-xl lg:max-w-2xl animate-fade-in-up">

          {/* Thin orange accent bar */}
          <div className="w-10 h-0.5 bg-primary-500 mb-7"></div>

          {/* Overline */}
          <span className="inline-block text-xs md:text-sm font-semibold tracking-[0.25em] uppercase text-primary-400 mb-5">
            Engenharia • Recuperação • Componentes Novos
          </span>

          {/* Headline */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl xl:text-6xl font-bold text-background-50 font-heading leading-[1.10] tracking-tight">
            Especialistas em Soluções Hidráulicas para Máquinas Pesadas e Equipamentos Industriais
          </h1>

          {/* Subheadline */}
          <p className="mt-6 text-base md:text-lg text-background-50/75 max-w-lg leading-relaxed">
            Recuperação de cilindros, bombas, motores e válvulas hidráulicas, além do fornecimento de componentes hidráulicos novos para equipamentos móveis e aplicações industriais.
          </p>

          {/* Trust indicators — moved up directly below subheadline, high contrast */}
          <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2.5">
            {TRUST_CHECKS.map((item, i) => (
              <span
                key={i}
                className="inline-flex items-center gap-1.5 text-xs md:text-sm text-background-50"
              >
                <span className="w-[18px] h-[18px] rounded-full bg-primary-500/20 flex items-center justify-center shrink-0">
                  <i className="ri-check-line text-[10px] text-primary-300"></i>
                </span>
                {item}
              </span>
            ))}
          </div>
        </div>
      </div>

      {/* ─── Bottom gradient ─── */}
      <div
        className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-b from-transparent to-background-50 pointer-events-none z-10"
        aria-hidden="true"
      ></div>
    </section>
  );
}